import { Flex, Text } from '@chakra-ui/react';
import { saveAs } from 'file-saver';
import {
  Button,
  CopyIcon,
  GmailColorIcon,
  GoogleSheetsLogoIcon,
  Modal,
  ModalBody,
  ModalHeaderDefault,
  useSnackbar,
} from 'ui-components';
import { apiClientV2 } from '~/api/client';
import { useCreatorCopyEmbed } from '~/hooks/useCreatorCopyEmbed';
import { ICreator } from '~/types';

interface ShareCreatorProps {
  creator: ICreator;
  isOpenModalShareCreator: boolean;
  onClose: () => void;
  handleClick: (e: React.MouseEvent) => void;
}

const ShareCreatorModal: React.FC<ShareCreatorProps> = ({
  creator,
  isOpenModalShareCreator,
  onClose,
  handleClick,
}) => {
  const snackbar = useSnackbar();
  const { onBasicClick, onDetailClick } = useCreatorCopyEmbed(creator);

  const handleExportSheet = async () => {
    try {
      const url = `/creators/${creator.id}/export/excel`;
      const res = await apiClientV2.get(url, {
        responseType: 'blob',
      });
      // Use the filename provided by the backend or create one based on the creator's fullName
      const fileName =
        res.headers['content-disposition']
          ?.split('filename=')?.[1]
          ?.replaceAll('"', '') || `${creator?.fullName}.xlsx`;

      saveAs(res.data, fileName);
    } catch (error) {
      snackbar.error({
        description: 'Error downloading the file',
      });
    }
  };

  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpenModalShareCreator}
      onClose={onClose}
      size="xs"
    >
      <ModalHeaderDefault title={`Share ${creator?.fullName}'s Profile`} />
      <ModalBody>
        <Button
          sx={{ w: 'full' }}
          onClick={handleClick}
          leftIcon={<CopyIcon />}
        >{`${creator?.slug}.foam.io`}</Button>
        <Text mb={2} mt={4} fontWeight={500} color="primary.500">
          Embeds
        </Text>
        <Flex w="full" justifyContent="space-between" gap={2}>
          <Button
            sx={{ w: 'full' }}
            variant="tertiary"
            onClick={onBasicClick}
            leftIcon={<GmailColorIcon />}
          >
            Copy basic embed
          </Button>
          {creator.hasConnectedPlatform && (
            <Button
              sx={{ w: 'full' }}
              variant="tertiary"
              onClick={onDetailClick}
              leftIcon={<GmailColorIcon />}
            >
              Copy detail embed
            </Button>
          )}
        </Flex>
        <Text mb={2} mt={4} fontWeight={500} color="primary.500">
          Export
        </Text>
        <Button
          sx={{ w: 'full' }}
          onClick={handleExportSheet}
          variant="tertiary"
          leftIcon={<GoogleSheetsLogoIcon />}
        >
          XLS
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default ShareCreatorModal;
